const REMOVED_PROPERTY_NAMES = new Set([
  "hash", "query", "ref", "referral", "search",
])

const ATTRIBUTION_TOKEN_NAMES = new Set([
  "dclid", "fbclid", "gad_source", "gbraid", "gclid", "igshid", "li_fat_id", "mc_cid", "msclkid", "twclid", "wbraid",
])

const URL_PROPERTY_NAMES = new Set([
  "current_url", "external_click_url", "from", "href", "initial_current_url", "initial_referrer", "path", "pathname", "referer", "referrer", "session_entry_url", "to", "url",
])

function normalizePropertyName(name: string) {
  return name.replace(/^\$/, "").replace(/([a-z0-9])([A-Z])/g, "$1_$2").toLowerCase()
}

function isPrivateProperty(name: string) {
  const normalized = normalizePropertyName(name)
  const attributionName = normalized.startsWith("initial_") ? normalized.slice("initial_".length) : normalized
  return (
    REMOVED_PROPERTY_NAMES.has(normalized) ||
    ATTRIBUTION_TOKEN_NAMES.has(attributionName) ||
    attributionName.startsWith("utm_") ||
    attributionName.startsWith("referral_") ||
    normalized === "address" || normalized.endsWith("_address") ||
    normalized === "amount" || normalized.endsWith("_amount") ||
    normalized.includes("invoice") || normalized.endsWith("_hash") ||
    normalized === "payment_request"
  )
}

function isUrlProperty(name: string) {
  const normalized = normalizePropertyName(name)
  return URL_PROPERTY_NAMES.has(normalized) || normalized.endsWith("_pathname") || normalized.endsWith("_url")
}

function sanitizeUrlValue(value: unknown) {
  if (typeof value !== "string") return value
  const trimmed = value.trim()
  if (!trimmed) return ""
  const scheme = trimmed.match(/^([a-z][a-z\d+.-]*):/i)?.[1]?.toLowerCase()
  if (scheme && scheme !== "http" && scheme !== "https") return ""
  try {
    const isAbs = !!scheme
    const p = new URL(trimmed, "https://privacy.invalid")
    return isAbs ? `${p.origin}${p.pathname}` : p.pathname
  } catch { return trimmed.split(/[?#]/, 1)[0] }
}

function removePrivateProperties(value: any): void {
  if (!value || typeof value !== "object") return
  if (Array.isArray(value)) { value.forEach(removePrivateProperties); return }
  Object.keys(value).forEach((key) => {
    if (isPrivateProperty(key)) { delete value[key]; return }
    if (isUrlProperty(key) && typeof value[key] === "string") {
      const s = sanitizeUrlValue(value[key])
      if (!s) delete value[key]; else value[key] = s
      return
    }
    removePrivateProperties(value[key])
  })
}

export function sanitizePosthogEvent(event: any) {
  removePrivateProperties(event?.properties)
  return event
}

export const posthogOptions = {
  before_send: sanitizePosthogEvent,
  capture_pageleave: "if_capture_pageview",
  capture_pageview: "history_change",
  disable_capture_url_hashes: true,
  save_campaign_params: false,
} as const
